export function getTaskCompletionError(message: string, errorCode?: string) {
  const notAssignee = errorCode === "QT_TASK_NOT_ASSIGNEE"
    || (!errorCode && message === "Chỉ người đã nhận việc mới được xử lý task.");
  return {
    variant: "warning" as const,
    manualClose: true,
    title: notAssignee ? "Bạn không thể xử lý công việc này" : "Chưa thể hoàn tất công việc",
    description: notAssignee
      ? "Chỉ người đã nhận việc mới được xử lý công việc.\nVui lòng liên hệ người đang xử lý hoặc người quản lý quy trình để được giao lại công việc."
      : message,
    errorCode,
  };
}
